// ============================================================================
// view.tasksWebform — the Task / To Do intake form at /dailys/tasks
// ============================================================================
// The form's ONLY render input is the security-filtered assignee picker, and
// it now arrives through the authenticated catalog resource rather than a
// presenter-side effect against the module Supabase client.
//
// The submit paths are deliberately NOT obligations. `task_submit` goes through
// the offline RPC queue and the To Do branch writes a todo_items row; a write
// is not a render read, so neither adds an obligation here and neither is
// residual legacy. Nothing on this surface reads App's global boot.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.tasksWebform',
  obligations: Object.freeze([Object.freeze({id: 'tasks.webform.assignees', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
